import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import LeaveMessage from '../entities/leaveMessage'
import Ajax from '@/lib/ajax'
import PageResult from '@/store/entities/page-result';

interface LeaveMessageState extends ListState<LeaveMessage> {
    editLeaveMessage: LeaveMessage;
}
class LeaveMessageModule extends ListModule<LeaveMessageState, any, LeaveMessage>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<LeaveMessage>(),
        loading: false,
        editLeaveMessage: new LeaveMessage(),
    }
    actions = {
        async getAll(context: ActionContext<LeaveMessageState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/LeaveMessage/GetAll', { params: payload.data });
            context.state.loading = false;            
            let page = reponse.data.result as PageResult<LeaveMessage>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },        
        async create(context: ActionContext<LeaveMessageState, any>, payload: any) {
            await Ajax.post('/api/services/app/LeaveMessage/Create', payload.data);
        },
        async update(context: ActionContext<LeaveMessageState, any>, payload: any) {
            await Ajax.put('/api/services/app/LeaveMessage/Update', payload.data);
        },
        async delete(context: ActionContext<LeaveMessageState, any>, payload: any) {
            await Ajax.delete('/api/services/app/LeaveMessage/Delete?Id=' + payload.data.id);
        }, 
        async auditedLeaveMessage(context: ActionContext<LeaveMessageState, any>, payload: any) {
            await Ajax.post('/api/services/app/LeaveMessage/AuditedLeaveMessage?id=' + payload.data.id);
        },        
        async get(context: ActionContext<LeaveMessageState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/LeaveMessage/Get?Id=' + payload.data.id);
            context.state.editLeaveMessage=reponse.data.result as LeaveMessage;
        }
    };
    mutations = {
        setCurrentPage(state: LeaveMessageState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: LeaveMessageState, pagesize: number) {
            state.pageSize = pagesize;
        },
        edit(state: LeaveMessageState, leaveMessage: LeaveMessage) {
            state.editLeaveMessage = leaveMessage;
        }
    }
}
const leaveMessageModule = new LeaveMessageModule();
export default leaveMessageModule;